import template from './loansAmountSimulationErrors.html';
import controller from './loansAmountSimulationErrors.controller';
import './loansAmountSimulationErrors.scss';

let loansAmountSimulationErrorsComponent = {
  restrict: 'E',
  bindings: {
    errors: '<',
    isMobileApp: '<',
    isClickOnSubmit: '<',
  },
  template,
  controller
};

export default loansAmountSimulationErrorsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulationErrors/loansAmountSimulationErrors.component.js